export class Neighborhood1073Layout {
	public sections = [
		{
			title: 'Neighborhood Description',
			items: [
				[
					{
						cssClass: 'col-sm-12 mb-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodDescription'
						}
					},
					{
						cssClass: 'col-sm-12 px-0',
						type: 'field',
						options: {
							displayType: 'map',
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLocation',
							address: [
								'CV_EXTENSION_SECTION.FIELDS.CVSubjectStreetAddress',
								'CV_EXTENSION_SECTION.FIELDS.CVSubjectState',
								'CV_EXTENSION_SECTION.FIELDS.CVSubjectPostalCode'
							],
							show: {
								label: false,
								value: true
							}
						}
					}
				]
			]
		},
		{
			title: 'Neighborhood Boundaries',
			items: [
				[
					{
						cssClass: 'col-sm-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodBoundaries'
						}
					}
				]
			]
		},
		{
			title: 'Neighborhood Characteristics',
			items: [
				[
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLocation'
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodMarketTime'
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodDemandType'
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodBuiltUp'
						}
					},
				],
				[
					{
						cssClass: 'col-sm-3 offset-sm-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodGrowth'
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodMarketingTimeTrend'
						}
					},
				],
				[
					{
						cssClass: 'col-sm-3',
						type: 'range',
						options: {
							label: 'Condominium Housing Price Range',
							fields: [
								{
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodHousingLowPriceAmount',
										displayType: 'thousands-currency',
										cssClass: 'd-inline-block',
										show: {
											label: false
										}
									}
								},
								{
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodHousingHighPriceAmount',
										cssClass: 'd-inline-block',
										displayType: 'thousands-currency',
										show: {
											label: false
										}
									}
								}
							]
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'range',
						options: {
							label: 'Condominium Housing Age Range',
							fields: [
								{
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodHousingNewestYearsCount',
										cssClass: 'd-inline-block',
										displayType: 'years',
										show: {
											label: false
										}
									}
								},
								{
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodHousingOldestYearsCount',
										cssClass: 'd-inline-block',
										displayType: 'years',
										show: {
											label: false
										}
									}
								}
							]
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodHousingPredominantPriceAmount',
							displayType: 'thousands-currency'
						}
					},
					{
						cssClass: 'col-sm-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodHousingPredominantAgeYearsCount',
							displayType: 'years'
						}
					},
				],
				[
					{
						cssClass: 'col-sm-3',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Land Use %',
									colSpan: 2
								},
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'One-Unit' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLandUseOneUnitPercent',
												displayType: 'percentage',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: { label: '2-4 Unit' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLandUse24UnitPercent',
												displayType: 'percentage',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: { label: 'Multi-Family' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLandUseMultiPercent',
												displayType: 'percentage',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: { label: 'Commercial' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLandUseCommercialPercent',
												displayType: 'percentage',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: { label: 'Other' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodLandUseOtherPercent',
												displayType: 'percentage',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-sm-9',
						type: 'static-table',
						options: {
							header: [
								{},
								{ label: 'Number' },
								{ label: 'Low Amount' },
								{ label: 'High Amount' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Neighborhood Listings' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodNumberofCompetingListings',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodComparableListingsPriceRangeLowAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodComparableListingsPriceRangeHighAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Neighborhood Sales' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodNumberofComparableSales',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodComparableSalesPriceRangeLowAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodComparableSalesPriceRangeHighAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Competing Listings' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodCompetingListings',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodCompetingListingsPriceRangeLowAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodCompetingListingsPriceRangeHighAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Competing Sales' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodCompetingSales',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodCompetingSalesPriceRangeLowAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodCompetingSalesPriceRangeHighAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
							]
						}
					}
				],
				[
					{
						cssClass: 'col-sm-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVNeighborhoodMarketConditions'
						}
					}
				]
			]
		},
		{
			title: 'Market',
			items: [
				[
					{
						cssClass: 'col-sm-12',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Inventory Analysis' },
								{ label: 'Prior 7-12 Months' },
								{ label: 'Prior 4-6 Months' },
								{ label: 'Current 3 Months' },
								{ label: 'Overall Trend' }
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Comparable Settled Sales' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalSalesPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalSalesPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalSalesLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalSalesOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Absorption Rate (Total Sales / Months)' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketAbsorptionRatePrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketAbsorptionRatePrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketAbsorptionRateLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketAbsorptionRateOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Comparable Active Listings' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalListingsPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalListingsPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalListingsLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTotalListingsOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Months of Housing Supply (Total Listings / Absorption Rate)' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSupplyPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSupplyPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSupplyLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSupplyOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								}
							]
						}
					},
					{
						cssClass: 'col-sm-12',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Median Sale & List Price, DOM, Sale / List Percentage' },
								{ label: 'Prior 7-12 Months' },
								{ label: 'Prior 4-6 Months' },
								{ label: 'Current 3 Months' },
								{ label: 'Overall Trend' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Median Comparable Sale Price' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesPricePrior7To12Months',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesPricePrior4To6Months',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesPriceLast3Months',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesPriceOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Median Comparable Sales: Days On Market' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesDaysPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesDaysPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesDaysLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSalesDaysOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Median Comparable List Price' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListPricePrior7To12Months',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListPricePrior4To6Months',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListPriceLast3Months',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListPriceOverallTrend',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Median Comparable Listings: Days On Market' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListingDaysPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListingDaysPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListingDaysLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianListingDaysOverall',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Median Sale Price as % of List Price' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSaleToRatioPrior7To12Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSaleToRatioPrior4To6Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSaleToRatioLast3Months',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketMedianSaleToRatioOverall',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
							]
						}
					}
				],
				[
					{
						cssClass: 'col-sm-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTrendsAdverseFinancingIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-sm-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTrendsAdverseFinancingTrendType'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketSalesConcessionDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTrendsForeclosureActivityIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-sm-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTrendsForeclosureActivityDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketDataSourceDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVMarketTrendsReconciliationComment'
						}
					}
				]
			]
		}
	];
}